/* eslint-disable */
import { useCallback, useEffect, useState } from "react";
import { Eye, PhoneIcon, RefreshCw, ChevronDown } from "lucide-react";
import { propertiesApi } from "./api";
import "./ExternalViewersAudit.css";

function relTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(1, Math.floor((Date.now() - then) / 1000));
  if (diff < 60) return `${diff}s ago`;
  const m = Math.floor(diff / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} day${d === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString();
}

function fmtPhone(raw) {
  const digits = String(raw || "").replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return raw;
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
}

export default function ExternalViewersAudit({ listingId }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const r = await propertiesApi.externalViewers(listingId);
      setRows(r || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [listingId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  return (
    <div className="vsp-au-card">
      <button
        type="button"
        className="vsp-au-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <Eye size={14} />
        <span>External viewers</span>
        {rows.length > 0 && <span className="vsp-au-badge">{rows.length}</span>}
        <ChevronDown
          size={14}
          className={`vsp-au-chev ${open ? "open" : ""}`}
        />
      </button>

      {open && (
        <div className="vsp-au-body">
          <p className="vsp-au-help">
            Non-member visitors who unlocked your contact via WhatsApp.
          </p>
          {error && <div className="vsp-au-error">{error}</div>}
          {loading && rows.length === 0 && (
            <div className="vsp-au-empty">Loading…</div>
          )}
          {!loading && rows.length === 0 && (
            <div className="vsp-au-empty">
              No external viewers yet. They'll show up here once someone
              outside Vishal Sanjivini requests your contact.
            </div>
          )}
          {rows.length > 0 && (
            <ul className="vsp-au-list">
              {rows.map((r) => (
                <li key={r.id}>
                  <div className="vsp-au-name">
                    <strong>{r.name || "Unknown"}</strong>
                    <span className="vsp-au-when">{relTime(r.verified_at)}</span>
                  </div>
                  <div className="vsp-au-phone">
                    <PhoneIcon size={11} />
                    <a href={`tel:+91${r.phone}`}>{fmtPhone(r.phone)}</a>
                  </div>
                </li>
              ))}
            </ul>
          )}
          <button
            type="button"
            className="vsp-au-refresh"
            onClick={load}
            disabled={loading}
          >
            <RefreshCw size={11} /> Refresh
          </button>
        </div>
      )}
    </div>
  );
}
